import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API, AUTH } from '@const'
import * as utils from '@utils'
import { Tree } from 'antd'
import 'antd/dist/antd.css'
import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormHelperText,
    Divider,
    Grid,
    FormControlLabel,
    Checkbox,
} from '@material-ui/core'

const initialState = {
    authorizationsTreeData: [],
    authorizationsCheckedKeys: [],
    authorizationsExpandedKeys: [],
    pfSubPfTreeData: [],
    pfSubPfCheckedKeys: [],
    pfSubPfExpandedKeys: [],
    needSetPf: false,
    id: 0,
    name: '',
    rootRoleID: 0,
    dialogOpen: false,
    roleList: [],
    canAccessAllPf: false,
    valid: false
}

class EditRoleDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'EditRoleDialog')
        }
        this.state = initialState
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset(roleInfo, roleList) {
        let authorizationsCheckedKeys = utils.deepCopy(roleInfo['authorization_list'])
        const rootRoleInfo =
            roleInfo['id'] === roleInfo['root_role_id']
                ? null
                : roleList.find((role) => {
                      return role['id'] === roleInfo['root_role_id']
                  })
        
        const authorizationsTreeData = utils.generateAuthTreeData(rootRoleInfo, roleInfo['root_role_id'])
        /** 過濾不該存在的權限 */
        authorizationsCheckedKeys = utils.filterRedundantAuthorization(authorizationsTreeData, authorizationsCheckedKeys)
        /** 由前端暫時移除權限表 */
        utils.tempRemoveAuthorization(authorizationsCheckedKeys)
        const authorizationsExpandedKeys = authorizationsCheckedKeys.reduce((arr, curr) => {
            if (curr.search(/(\.|\/)/) < 0) {
                arr.push(curr)
            } else {
                if (curr.indexOf('.') > -1) {
                    arr.push(curr.slice(0, curr.indexOf('.')))
                }
                if (curr.indexOf('/') > -1) {
                    arr.push(curr.slice(0, curr.indexOf('/')))
                }
            }
            return arr
        }, [])

        const pfSubPfCheckedKeys = roleInfo['pf_sub_pf_id_list'] || []
        const pfSubPfExpandedKeys = pfSubPfCheckedKeys.reduce((arr, curr) => {
            const temp = curr.split('_')
            if (arr.indexOf(temp[0]) < 0) {
                arr.push(temp[0])
            }
            return arr
        }, [])

        
        // console.log(utils.generateAuthTreeData(rootRoleInfo))
        // console.log(authorizationsCheckedKeys)

        this.setState({
            authorizationsTreeData,
            authorizationsCheckedKeys: authorizationsCheckedKeys,
            authorizationsExpandedKeys: authorizationsExpandedKeys,
            pfSubPfTreeData: utils.generatePfTreeData(rootRoleInfo),
            pfSubPfCheckedKeys: pfSubPfCheckedKeys,
            pfSubPfExpandedKeys: pfSubPfExpandedKeys,
            needSetPf: pfSubPfCheckedKeys.length > 0,
            id: roleInfo['id'],
            rootRoleID: roleInfo['root_role_id'],
            name: roleInfo['name'],
            canAccessAllPf: roleInfo['can_access_all_pf'],
        })
    }

    OpenDialog(roleInfo, roleList) {
        this.reset(roleInfo, roleList)
        this.setState({
            dialogOpen: true,
            valid: false
        })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    confirm() {
        if (this.props.confirmCallback) {
            this.props.confirmCallback()
        }
        this.closeDialog()
    }

    handleValidation() {
        let valid = false
        valid = this.state.name && String(this.state.name).length <= 20
        return valid
    }

    handleRoleEdit() {
        return utils.checkValid('role.edit')
    }

    render() {
        return (
            <Dialog id="edit-role-dialog" maxWidth="md" fullWidth open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle>{ this.handleRoleEdit() ? this.t('Title') : this.t('View')}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                autoFocus
                                label={this.t('name')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.name}
                                onChange={(event) =>
                                    this.setState({
                                        name: event.target.value,
                                    })
                                }
                                disabled={!this.handleRoleEdit()}
                                margin="dense"
                                fullWidth
                                required={true}
                                error={this.state.valid && !this.handleValidation()}
                                helperText={this.state.valid && !this.handleValidation() ? this.t('nameValidError'): ''}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormHelperText>
                                <React.Fragment>
                                    {this.t('authorizations')}
                                    {this.handleRoleEdit() && <Button
                                        style={{ marginLeft: '40%', marginRight: '5%' }}
                                        className={this.props.classes.linkButton}
                                        onClick={() => {
                                            this.setState({
                                                authorizationsCheckedKeys: utils.getTreeAllKeys(this.state.authorizationsTreeData),
                                            })
                                        }}>
                                        {this.t('selectAll')}
                                    </Button>}
                                    {this.handleRoleEdit() && <Button
                                        className={this.props.classes.linkButton}
                                        onClick={() => {
                                            this.setState({
                                                authorizationsCheckedKeys: [],
                                            })
                                        }}>
                                        {this.t('unselectAll')}
                                    </Button>}
                                </React.Fragment>
                            </FormHelperText>
                            <Tree
                                treeData={this.state.authorizationsTreeData}
                                checkedKeys={this.state.authorizationsCheckedKeys}
                                expandedKeys={this.state.authorizationsExpandedKeys}
                                onCheck={(checkedKeys) => {
                                    this.setState({
                                        authorizationsCheckedKeys: checkedKeys,
                                    })
                                }}
                                onExpand={(expandedKeys) => {
                                    this.setState({
                                        authorizationsExpandedKeys: expandedKeys,
                                    })
                                }}
                                checkable={true}
                                selectable={false}
                                style={{
                                    maxHeight: '40vh',
                                    overflowY: 'auto',
                                }}
                                disabled={!this.handleRoleEdit()}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            {this.state.rootRoleID === AUTH.ROLE_ID_ADMIN && (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.canAccessAllPf}
                                            onChange={(event) => {
                                                this.setState({
                                                    canAccessAllPf: event.target.checked,
                                                })
                                            }}
                                            color="primary"
                                            disabled={!this.handleRoleEdit()}
                                        />
                                    }
                                    label={this.t('canAccessAllPf')}
                                />
                            )}
                            {!this.state.canAccessAllPf && (
                                <React.Fragment>
                                    <FormHelperText>
                                        <React.Fragment>
                                            {this.t('pfSubPf')}
                                            {this.handleRoleEdit() && <Button
                                                style={{ marginLeft: '40%', marginRight: '5%' }}
                                                className={this.props.classes.linkButton}
                                                onClick={() => {
                                                    this.setState({
                                                        pfSubPfCheckedKeys: utils.getTreeAllKeys(this.state.pfSubPfTreeData),
                                                    })
                                                }}>
                                                {this.t('selectAll')}
                                            </Button>}
                                            {this.handleRoleEdit() && <Button
                                                className={this.props.classes.linkButton}
                                                onClick={() => {
                                                    this.setState({
                                                        pfSubPfCheckedKeys: [],
                                                    })
                                                }}>
                                                {this.t('unselectAll')}
                                            </Button>}
                                        </React.Fragment>
                                    </FormHelperText>
                                    <Tree
                                        treeData={this.state.pfSubPfTreeData}
                                        checkedKeys={this.state.pfSubPfCheckedKeys}
                                        expandedKeys={this.state.pfSubPfExpandedKeys}
                                        onCheck={(checkedKeys) => {
                                            this.setState({
                                                pfSubPfCheckedKeys: checkedKeys,
                                            })
                                        }}
                                        onExpand={(expandedKeys) => {
                                            this.setState({
                                                pfSubPfExpandedKeys: expandedKeys,
                                            })
                                        }}
                                        checkable={true}
                                        selectable={false}
                                        style={{
                                            maxHeight: '40vh',
                                            overflowY: 'auto',
                                        }}
                                        disabled={!this.handleRoleEdit()}
                                    />
                                </React.Fragment>
                            )}
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    {this.handleRoleEdit() && <>
                        <Button
                            variant="contained"
                            onClick={() => {
                                const pfSubPfIDList = this.state.pfSubPfCheckedKeys.filter((ele) => ele.search(/_/) > -1)
                                const authList = this.state.authorizationsCheckedKeys.filter((ele) => ele.search(/\./) > -1)
                                let error = false
                                this.setState({
                                    valid: true
                                })
                                error = !this.handleValidation()
                                /** 最高權限未使用"允许存取所有平台",且無勾選任何平台 */
                                if ((false === this.state.canAccessAllPf && this.state.rootRoleID === AUTH.ROLE_ID_ADMIN) && !pfSubPfIDList.length) {
                                    utils.addToast(this.t('pfValidError'), 'error')
                                    error = true
                                }
                                /** 非最高權限且無勾選任何平台 */
                                if (this.state.rootRoleID !== AUTH.ROLE_ID_ADMIN && !pfSubPfIDList.length) {
                                    utils.addToast(this.t('pfValidError'), 'error')
                                    error = true
                                }
                                if (!authList.length) {
                                    utils.addToast(this.t('authValidError'), 'error')
                                    error = true
                                }
                                if (error) { return }
                                utils.apiRequest(
                                    'put',
                                    API.ROLE,
                                    {
                                        id: this.state.id,
                                        name: this.state.name,
                                        can_access_all_pf: this.state.canAccessAllPf,
                                        pf_sub_pf_id_list: pfSubPfIDList,
                                        // only leaf node
                                        authorization_list: authList,
                                    },
                                    (_data) => {
                                        this.confirm()
                                    }
                                )
                            }}
                            color="primary">
                            {this.t('confirm')}
                        </Button>
                        <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                            {this.t('cancel')}
                        </Button>
                    </>}
                    {!this.handleRoleEdit() && <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('close')}
                    </Button>}
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {
        linkButton: {
            background: 'none!important',
            border: 'none',
            padding: '0!important',
            color: '#1890ff',
            textDecoration: 'none',
            cursor: 'pointer',
            userSelect: 'text',
            fontSize: '0.75rem',
        },
    }
}

EditRoleDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
    dataService: PropTypes.object,
}

export default hoc(styles)(EditRoleDialog)
